import React from 'react';
import styled from 'styled-components';

import EmailGrabber from './EmailGrabber';
import QuotesCarousel from './QuotesCarousel';

const MainContainer = styled.div `
    position: relative;
    padding: 70px 100px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1920px;
    margin: 0 auto;

    @media (max-width: 995px){
        padding: 15px;
        justify-content: center;
    }
`;

const EmailGrabberContainer = styled.div `
    width: 50%;
    padding-right: 5%;

    @media (max-width: 995px){
        width: 100%;
        padding-right: 0;
        margin-bottom: 40px;
    }
`;

const QuotesContainer = styled.div `
    width: 50%;
    padding-top: 40px;

    @media (max-width: 995px){
        width: 100%;     
        padding-top: 0;   
        margin-bottom: 40px;
    }
`;

const EmailGrabberWithQuotes = ({
    maropostID = 0,
    title = "#fff",
    titleColor = "#fff",
    text = "",
    textColor = "#fff",
    buttonBackground = "#01f4e0",
    buttonBackgroundHover = "#09c6cd",
    buttonColor = "#000",
    buttonColorHover = "#000",
    buttonText = 'Submit',
    placeholderText = 'Email Address',
    confirmText = 'Thanks! Please check your email for confirmation',
    inputBackground = "#fff",
    inputColor = "#000",
    inputPlaceholderColor = "#A6A6A6",
    inputBorderColor = "transparent",
    inputBorderColorFocus = "#01f4e0",
    quotesColor = "#fff",
    quotesAuthorColor = "#fff",
    quotes = []
}) => (
    <MainContainer>
		<EmailGrabberContainer>
            <EmailGrabber 
                maropostID={ maropostID } 
                title={ title } 
                titleColor={ titleColor } 
                text={ text } 
                textColor={ textColor } 
                buttonBackground= { buttonBackground }
                buttonBackgroundHover= { buttonBackgroundHover }
                buttonColor= { buttonColor }
                buttonColorHover= { buttonColorHover }
                buttonText={buttonText}
                placeholderText={placeholderText}
                confirmText={confirmText}
                inputBackground= { inputBackground }
                inputColor= { inputColor }
                inputPlaceholderColor= { inputPlaceholderColor }
                inputBorderColor= { inputBorderColor }
                inputBorderColorFocus= { inputBorderColorFocus }
            />
		</EmailGrabberContainer>
        <QuotesContainer>
            <QuotesCarousel 
                quotes={ quotes } 
                quotesColor={ quotesColor } 
                quotesAuthorColor={ quotesAuthorColor } 
            />
        </QuotesContainer>
	</MainContainer>
);

export default EmailGrabberWithQuotes;
